module.exports = __webpack_public_path__ + "img/slider_16.9212526c.jpg";